export default __webpack_public_path__ + "static/media/reims9.1b98be8d.jpg";